import { Box, Typography, Button } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { useTranslation } from 'react-i18next'

interface ErrorStateProps {
  message?: string
  onRetry?: () => void
}

export default function ErrorState({ message, onRetry }: ErrorStateProps) {
  const { t } = useTranslation()
  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', py: 6, color: 'error.main',
    }}>
      <ErrorOutlineIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography variant="body1">{message ?? t('EXECUTIVE.ERROR')}</Typography>
      {onRetry && (
        <Button variant="outlined" size="small" onClick={onRetry} sx={{ mt: 1 }}>
          {t('EXECUTIVE.RETRY')}
        </Button>
      )}
    </Box>
  )
}
